import { supabase } from './supabase'
import { readDataset, saveDataset } from './cache'
import { DATASETS } from './datasets'
import type { DatasetKey } from '../types'

export type DatasetLoadResult = {
  records: Record<string, unknown>[]
  source: 'online' | 'cache'
  savedAt: string | null
}

export async function loadDataset(key: DatasetKey): Promise<DatasetLoadResult> {
  const { data, error } = await supabase
    .from(key)
    .select('*')
    .order('id', { ascending: true })

  if (!error && data) {
    const records = data as Record<string, unknown>[]
    saveDataset(key, records)
    return { records, source: 'online', savedAt: new Date().toISOString() }
  }

  const cached = readDataset(key)
  if (cached) {
    return { records: cached.records, source: 'cache', savedAt: cached.savedAt }
  }

  throw error ?? new Error(`Base ${key} indisponível e sem cache local.`)
}

export async function loadDatasetCounts() {
  const results = await Promise.all(
    DATASETS.map(async ({ key }) => {
      const result = await loadDataset(key)
      return [key, { count: result.records.length, source: result.source }] as const
    }),
  )

  return Object.fromEntries(results)
}
